import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { userForgetPasswordReset } from '../../api/User';
import { Form, Input, message, Button } from 'antd';

const PageContainer = styled.div`
  width: 100%;
  height: calc(100vh - 181px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PageContent = styled.div`
  width: 100%;
  max-width: 600px;
`;

const PageTitle = styled.div`
  font-size: 32px;
  color: #fff;
  margin-bottom: 50px;
`;

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [KEY, setKEY] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  // 验证邮箱
  const Verfiy = async (values) => {
    setLoading(true);
    try {
      const { code } = await userForgetPasswordReset({
        password_reset_key: KEY,
        ...values,
      });
      if (code === '10000') {
        message.success('Verification succeeded');
        setLoading(false);
        navigate('/login');
      } else {
        setLoading(false);
        navigate('/');
      }
    } catch (error) {
      // console.log(error);
    }
    setLoading(false);
  };

  // 获取url 中的 password_reset_key
  useEffect(() => {
    const key = location.search.split('?password_reset_key=')[1];
    setKEY(key);
  }, []);

  const handleFinshFailed = (error) => {
    message.error(error.message);
  };

  const handleFormFinsh = async (values) => {
    Verfiy(values);
  };

  return (
    <PageContainer>
      <PageContent>
        <PageTitle>Reset Password</PageTitle>
        <Form
          layout={'vertical'}
          autoComplete="off"
          requiredMark={false}
          onFinish={handleFormFinsh}
          onFinishFailed={handleFinshFailed}
        >
          <Form.Item
            name={'new_password'}
            label="New Password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input type={'password'} className="reset-password-input" />
          </Form.Item>
          <Form.Item
            name={'new_password_confirmation'}
            label="Confirm Password"
            dependencies={['new_password']}
            rules={[
              { required: true, message: 'Please input your password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error(
                      'The two passwords that you entered do not match!'
                    )
                  );
                },
              }),
            ]}
          >
            <Input type={'password'} className="reset-password-input" />
          </Form.Item>
          <Form.Item>
            <Button
              type={'text'}
              htmlType={'submit'}
              loading={loading}
              className="reset-password-btn"
            >
              Reset
            </Button>
          </Form.Item>
        </Form>
      </PageContent>
    </PageContainer>
  );
};

export default ResetPassword;
